/**
 * Dot Navigation
 *
 * Auto-generates vertical dot navigation from fullscreen sections.
 * Uses Intersection Observer to track active section.
 * Desktop only (>= 1024px) - hidden and disabled on mobile/tablet.
 */
(function() {
  'use strict';

  // Only initialize on desktop
  if (window.innerWidth < 1024) return;

  const nav = document.querySelector('[data-dot-nav]');
  const sections = document.querySelectorAll('[data-fullscreen-section]');

  if (!nav || sections.length === 0) return;

  // Generate dots
  sections.forEach(function(section, index) {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'dot-nav__dot w-3 h-3 rounded-full bg-white/30 hover:bg-white/60 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-yellow focus:ring-offset-2 focus:ring-offset-black';
    dot.setAttribute('data-dot-index', index);
    dot.setAttribute('aria-label', 'Go to section ' + (index + 1));

    // Click handler
    dot.addEventListener('click', function() {
      section.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });

    nav.appendChild(dot);
  });

  const dots = nav.querySelectorAll('.dot-nav__dot');

  // Track active section with Intersection Observer
  const observerOptions = {
    root: null,
    rootMargin: '-40% 0px -40% 0px',
    threshold: 0
  };

  let currentActiveIndex = 0;

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        const index = Array.from(sections).indexOf(entry.target);
        if (index !== -1) {
          setActiveDot(index);
        }
      }
    });
  }, observerOptions);

  sections.forEach(function(section) {
    observer.observe(section);
  });

  /**
   * Set the active dot
   */
  function setActiveDot(index) {
    if (index === currentActiveIndex) return;

    dots.forEach(function(dot, i) {
      if (i === index) {
        dot.classList.remove('bg-white/30');
        dot.classList.add('bg-white', 'scale-125');
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.classList.add('bg-white/30');
        dot.classList.remove('bg-white', 'scale-125');
        dot.removeAttribute('aria-current');
      }
    });

    currentActiveIndex = index;
  }

  // Set initial active dot
  setActiveDot(0);

  // Keyboard navigation
  nav.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
      e.preventDefault();
      const nextIndex = Math.min(currentActiveIndex + 1, sections.length - 1);
      dots[nextIndex].click();
      dots[nextIndex].focus();
    } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
      e.preventDefault();
      const prevIndex = Math.max(currentActiveIndex - 1, 0);
      dots[prevIndex].click();
      dots[prevIndex].focus();
    }
  });
})();
